module.exports = __webpack_public_path__ + "static/media/floor_sw2.a872ee5d.png";